import { action } from "typesafe-actions";
import {
  Monitoring,
  // MonitoringState,
  MonitoringTypes,
} from "./types";

// type params = { external_attendance_id: string; type: string | undefined };

export const loadRequest = (data: any) => action(MonitoringTypes.LOAD_REQUEST, data);
export const loadSuccess = (data: Monitoring) => action(MonitoringTypes.LOAD_SUCCESS, data);
export const loadFailure = () => action(MonitoringTypes.LOAD_FAILURE);